/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Judges_Guide_DescriptionInputs */



/**
* | output |
* | --- |
* | "Tournament conduct and infraction guide for judges." |
*
* @param {Help_Judges_Guide_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const help_judges_guide_description = /** @type {((inputs?: Help_Judges_Guide_DescriptionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Judges_Guide_DescriptionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Guide de conduite et des infractions en tournoi, à l'usage des arbitres.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guía de conducta e infracciones en torneos para jueces.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Guia de conduta e infrações em torneios para juízes.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Guida alla condotta e alle infrazioni nei tornei, per i giudici.")
	return /** @type {LocalizedString} */ ("Tournament conduct and infraction guide for judges.")
});